import ApiClient, { BrowserAccessTokenStorage } from '~/ApiClient';
import { ApiClientLogger } from '~/Logger';

export default function createBrowserApiClient(baseUrl: string) {
	return new ApiClient(
		baseUrl,
		new BrowserAccessTokenStorage('access-token', {
			path: '/',
			httpOnly: false,
		}),
		new ApiClientLogger()
	);
}
